import { Injectable } from '@angular/core';
import { AppErrorContext } from '../../models/app-error-context.model';

/**
 * Holds the most recent error context so the generic error page can show when the error happened
 * and offer a "Try again" back to the originating route. It carries no internal error detail
 * (PLAN-2069).
 *
 * It is a one-shot handoff: the error page calls {@link consumeError} to read and clear it, so a
 * later direct visit to /error does not resurface a stale error.
 */
@Injectable({
  providedIn: 'root'
})
export class ErrorContextService {
  private _lastError: AppErrorContext | null = null;

  /** Records that an error occurred on the given route, stamped with the current time. */
  recordError(originUrl: string): void {
    this._lastError = { timestamp: new Date(), originUrl };
  }

  /** Returns the last error context (if any) and clears it. */
  consumeError(): AppErrorContext | null {
    const error = this._lastError;
    this._lastError = null;
    return error;
  }

  hasError(): boolean {
    return this._lastError !== null;
  }
}
